<ng-container *ngIf="!isLoading; else spinner">
  <h1 mat-dialog-title>Add {{ facilityType | titlecase }} to {{ airport.name }}:</h1>
  <mat-dialog-content [formGroup]='formGroup'>
    <div class="form-container">
      <mat-form-field>
        <input matInput formControlName="name" placeholder="Name of Business *">
      </mat-form-field>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button (click)="onSubmit()" [disabled]="!formGroup.valid">Submit</button>
    <button mat-button mat-dialog-close>Cancel</button>
  </mat-dialog-actions>
</ng-container>
<ng-template id="spinnerContainer" #spinner>
  <mat-dialog-content>
    <mat-spinner class="spinner" [diameter]="200" [color]="'accent'"></mat-spinner>
  </mat-dialog-content>
</ng-template>
